import {
  ButtonLink,
  ErrorListItem,
  ListContentIsland,
  NoTransactionsListItem,
  SkeletonListItem,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useTransactionsInfinityQuery } from '../../../api/transactions';
import { TransactionListItem } from '../../Transaction/Transaction';
import { useMemo } from 'react';

export function LastTransactions(props: { cardId?: string; accountId?: string; vaultId?: string }) {
  const { t } = useTranslation();

  const transactionsQuery = useTransactionsInfinityQuery(props);

  const lastTransactions = useMemo(
    () => transactionsQuery.data?.pages[0].transactions.slice(0, 6),
    [transactionsQuery],
  );

  return (
    <ListContentIsland
      title={t(`Last transactions`)}
      actions={
        <ButtonLink variant="text" color="info" to="/account/transactions" search={props}>
          {t('View all')}
        </ButtonLink>
      }
    >
      {transactionsQuery.isPending ? (
        <>
          <SkeletonListItem />
          <SkeletonListItem />
          <SkeletonListItem />
        </>
      ) : transactionsQuery.isError ? (
        <ErrorListItem error={transactionsQuery.error} />
      ) : lastTransactions?.length ? (
        lastTransactions.map((transaction) => (
          <TransactionListItem key={transaction.id} transaction={transaction} />
        ))
      ) : (
        <NoTransactionsListItem />
      )}
    </ListContentIsland>
  );
}
